import {AbstractPart} from "./AbstractPart";
import {IFormPartParameters} from "./index";
import {nsForm} from "../../nsForm";
import {validateEmail} from "../../../../util/misc";
import str2Bool = nsForm.str2Bool;
import inputboxHtml from './inputbox.html?raw';

export let template = inputboxHtml;

export class viewModel extends AbstractPart {
    private isRequired: boolean;
    private pattern: string | null = null;
    private type: TInputType = 'text';

    constructor(params: IFormPartParameters) {
        super(params);
        switch (this.value()) {
            case undefined:
            case null:
                this.value(this.parameters[2] ?? '');
        }
        const tOrP = this.parameters[4] as TInputType;
        if (tOrP) {
            if (nsForm.ALL_TYPES.includes(tOrP)) {
                this.type = tOrP;
            } else {
                this.pattern = tOrP;
            }
        }
        this.isRequired = str2Bool(this.parameters[3] ?? '');
        this.attr = {
            ...(this.pattern != null ? {pattern: this.pattern} : {}),
            required: this.isRequired,
            type: this.type,
        };
    }

    override isValid(): boolean {
        const message = this.getErrorMessage();
        const isValid = !message;
        this.et.update(!isValid, this.value, message ?? undefined);
        return isValid;
    }

    private getErrorMessage(): string | null {
        const v = this.value();
        if (this.isRequired && !v) {
            return 'Invalid value';
        }
        switch (this.type) {
            case "email":
                if (!validateEmail(String(v ?? ''))) return 'Invalid s|s:((email|ac))';
                break;
            case "number":
                if (isNaN(Number(v))) return 'Invalid s|s:((number|ac))';
                if (String(Number(v)) != v) return 'Invalid s|s:((number|ac))';
                break;
            case "tel":
                if (String(v).length < 8) return 'Invalid s|s:((phone number|ac))';
                break;
        }
        return null;
    }

}
